import { FC } from "react";

interface DispPhoneNumberProps {
  value?: string | null;
}

const DispPhoneNumber: FC<DispPhoneNumberProps> = ({ value }: DispPhoneNumberProps) => {
  if (!value) {
    return <>{value}</>;
  }

  return <>{<a href={`tel:${value.replace(/\s+/g, "")}`}>{value}</a>}</>;
};

export default DispPhoneNumber;
